import React from 'react';

import PsychToolPageBase, { PsychToolPageProps } from './PsychToolPageBase';

const PsychScl90Page: React.FC<PsychToolPageProps> = ({ onBack, onRequireLogin }) => (
  <PsychToolPageBase onBack={onBack} onRequireLogin={onRequireLogin} testId='scl90' />
);

export default PsychScl90Page;
